// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1_8w7","containerItemsCenter":"Skeleton_containerItemsCenter__3DtVJ"};